// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { section, title } from 'styles/jss/original/base';

const styles = {
  section,
  title: {
    ...title,
    marginTop: '10px',
    fontSize: '1.5625rem',
    '@media (max-width: 640px)': {
      fontSize: '1.3rem'
    },
    '@media (max-width: 320px)': {
      fontSize: '1.1rem'
    }
  },
  snsIcon: {
    display: 'flex',
    margin: '0',
    padding: '0'
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '25px'
  },
  flexItem: {
    listStyle: 'none'
  }
};

export default styles;
